import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import memoize from 'lodash/memoize';
import { EmojiResource } from '@atlaskit/emoji/resource';
var BASE_URL = process.env.NODE_ENV === 'development' ? 'https://sdog.jira-dev.com/gateway/api/emoji' : '/gateway/api/emoji';
var getEmojiConfig = function getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks) {
  var currentUser = userId ? {
    id: userId
  } : undefined;
  var providers = [{
    url: "".concat(BASE_URL, "/standard")
  }, {
    url: "".concat(BASE_URL, "/atlassian")
  }];
  if (cloudId) {
    providers.push({
      url: "".concat(BASE_URL, "/").concat(cloudId, "/site")
    });
  }
  var config = _objectSpread({
    providers: providers,
    allowUpload: !!userId && !disableUpload,
    currentUser: currentUser
  }, emojiLoadCallbacks || {});
  if (emojiSSRConfig) {
    return _objectSpread(_objectSpread({}, config), emojiSSRConfig);
  }
  return config;
};
var resolverOfMemoize = function resolverOfMemoize(extraConfig) {
  var _extraConfig$cloudId, _extraConfig$userId, _extraConfig$disableU;
  var cloudId = (_extraConfig$cloudId = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) !== null && _extraConfig$cloudId !== void 0 ? _extraConfig$cloudId : '';
  var userId = (_extraConfig$userId = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) !== null && _extraConfig$userId !== void 0 ? _extraConfig$userId : '';
  var disableUpload = (_extraConfig$disableU = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload) !== null && _extraConfig$disableU !== void 0 ? _extraConfig$disableU : false;
  var emojiSSRConfigString = extraConfig !== null && extraConfig !== void 0 && extraConfig.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
  return "".concat(cloudId, "_").concat(userId, "_").concat(disableUpload, "_").concat(emojiSSRConfigString);
};
var getEmojiResource = memoize(function (extraConfig) {
  var _extraConfig$cloudId2, _extraConfig$userId2, _extraConfig$emojiSSR;
  var cloudId = (_extraConfig$cloudId2 = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) !== null && _extraConfig$cloudId2 !== void 0 ? _extraConfig$cloudId2 : '';
  var userId = (_extraConfig$userId2 = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) !== null && _extraConfig$userId2 !== void 0 ? _extraConfig$userId2 : undefined;
  var disableUpload = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload;
  var emojiSSRConfig = (_extraConfig$emojiSSR = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.emojiSSRConfig) !== null && _extraConfig$emojiSSR !== void 0 ? _extraConfig$emojiSSR : undefined;
  var emojiConfig = getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
  return new EmojiResource(emojiConfig);
}, resolverOfMemoize);
export var getEmojiProvider = memoize(function (extraConfig) {
  var emojiResource = getEmojiResource(extraConfig);
  return emojiResource.getEmojiProvider();
}, resolverOfMemoize);